//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.SelectBaseEdgeConditionSymbol.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/SelectObject.js";
let d=[[[1,"Inherit",0,"Annotations.SelectBaseEdgeConditionSymbol",0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[0,"LimitDeviation",1,0],[0,"LimitDeviationA1",1,0],[0,"LimitDeviationA2",1,0],[0,"LimitDeviationB1",1,0],[0,"LimitDeviationB2",1,0],[0,"LimitDeviationC1",1,0],[0,"LimitDeviationC2",1,0],[0,"Method",1,0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"SymbolElement",1,0],[0,"Terminator",1,0]],[[["ecsTag"],"InheritProperties",{},1,0]],[]];
SPLM.Annotations.BaseEdgeConditionSymbolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BaseEdgeConditionSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BaseEdgeConditionSymbolBuilder.MethodType = Object.freeze({
    "Basic" : "Basic", "UndefinedDirectionandSize" : "UndefinedDirectionandSize", "UndefinedDirectionDefinedSize" : "UndefinedDirectionDefinedSize", "UndefinedDirectionEqualBilateralSize" : "UndefinedDirectionEqualBilateralSize", "DefinedDirection" : "DefinedDirection"});

SPLM.Annotations.BaseEdgeConditionSymbolBuilder.SymbolElementEnum = Object.freeze({
    "Plus" : "Plus", "Minus" : "Minus"});

SPLM.Annotations.BaseEdgeConditionSymbolBuilder.TerminatorType = Object.freeze({
    "Arrow" : "Arrow", "ExternalIndicator" : "ExternalIndicator", "InternalIndicator" : "InternalIndicator"});

export default SPLM;